import { Action } from 'redux';
import 'rxjs';
import { ActionsObservable, StateObservable } from 'redux-observable';
import { RootState } from '.';
import { empty, of, Observable } from 'rxjs';
import { switchMap, mergeMap, map, filter, catchError } from 'rxjs/operators';
import { ajax, AjaxResponse } from 'rxjs/ajax';
import { SUBMIT_LOGIN_FULFILLED, TOGGLE_CHECKOUT, ToggleCheckout } from './login';

export const LOAD_ORDERS = "WEBSHOP_LOAD_ORDERS";
export const LOAD_ORDERS_FULFILLED = "WEBSHOP_LOAD_ORDERS_FULFILLED";
export const LOAD_ORDERS_FAILED = "WEBSHOP_LOAD_ORDERS_FAILED";

export const SUBMIT_PAYMENT = "WEBSHOP_SUBMIT_PAYMENT";
export const SUBMIT_PAYPAL = "WEBSHOP_SUBMIT_PAYPAL";
export const SUBMIT_PAYMENT_FULFILLED = "WEBSHOP_SUBMIT_PAYMENT_FULFILLED";
export const SUBMIT_PAYPAL_FULFILLED = "WEBSHOP_SUBMIT_PAYPAL_FULFILLED";
export const SUBMIT_PAYMENT_FAILED = "WEBSHOP_SUBMIT_PAYMENT_FAILED"
export const SEND_EMAIL = "WEBSHOP_SEND_EMAIL";
export const SEND_EMAIL_FULFILLED = "WEBSHOP_SEND_EMAIL_FULFILLED";
export const SEND_EMAIL_FAILED = "WEBSHOP_SEND_EMAIL_FAILED";

export interface LoadOrdersFulfilled extends Action {
    type: "WEBSHOP_LOAD_ORDERS_FULFILLED",
    orders: string[]
}

export interface LoadOrdersFailed extends Action {
    type: "WEBSHOP_LOAD_ORDERS_FAILED",
}

export interface SubmitPayment extends Action {
    type: "WEBSHOP_SUBMIT_PAYMENT",
    request: PaymentRequest
}

export interface SubmitPayPal extends Action {
    type: "WEBSHOP_SUBMIT_PAYPAL",
    request: PaypalRequest
}

export interface SendEmail extends Action {
    type: "WEBSHOP_SEND_EMAIL",
    request: EmailRequest
}

export interface SendEmailFulfilled extends Action {
    type: "WEBSHOP_SEND_EMAIL_FULFILLED"
}
export interface SendEmailFailed extends Action {
    type: "WEBSHOP_SEND_EMAIL_FAILED"
}

export interface SubmitPaymentFulfilled extends Action {
    type: "WEBSHOP_SUBMIT_PAYMENT_FULFILLED",
    result: PaymentResult
}

export interface SubmitPaypalFulfilled extends Action {
    type: "WEBSHOP_SUBMIT_PAYPAL_FULFILLED"
    result: PaymentResult
}

export interface SubmitPaymentFailed extends Action {
    type: "WEBSHOP_SUBMIT_PAYMENT_FAILED",
    result?: PaymentResult,
    status_code?: number
}
export type WebshopState = {
    orders: Set<string>
    submitting: boolean,
    submitted: boolean,
    failed: boolean,
    result?: PaymentResult,
    vendor?: string
}

const initialState: WebshopState = {
    orders: new Set(),
    submitting: false,
    submitted: false,
    failed: false
};

export type WebshopAction = LoadOrdersFulfilled | LoadOrdersFailed | SubmitPayment | SubmitPayPal | SubmitPaymentFailed | SubmitPaymentFulfilled | SubmitPaypalFulfilled | ToggleCheckout | SendEmail | SendEmailFulfilled | SendEmailFailed;


export interface PaymentRequest {
    single_use_key: string,
    items: LineItem[]
}

export interface PaypalRequest {
    items: LineItem[]
}

export interface EmailRequest {
    to: string,
    subject: string,
    items: LineItem[],
    transaction_id: string | undefined,
    subtotal: number,
}

export interface LineItem {
    id: string,
    name: string,
    cost: number
}

export interface PaymentResult {
    transaction_id?: string,
    username: string,
    items: LineItem[],
    status: "approved" | "rejected",
    message?: string
}

export const submitPayment = (action$: ActionsObservable<Action>, state$: StateObservable<RootState>): Observable<Action> =>
    action$.ofType(SUBMIT_PAYMENT).pipe(
        mergeMap(action => {

            return ajax.post("api/v1/webshop/orders", (action as SubmitPayment).request,  { "SBPPortal-Ticket": state$.value.login.ticket, "user": state$.value.login.username, "email": state$.value.login.email, 'Content-Type': 'application/json' })
                .pipe(map(response => {

                    let result: PaymentResult = response.response;
                    return {
                        type: result.status == "approved" ? SUBMIT_PAYMENT_FULFILLED : SUBMIT_PAYMENT_FAILED,
                        result,
                        vendor: "westpac"
                    }
                }),
                catchError((error) => of({ type: SUBMIT_PAYMENT_FAILED })))

        }));

export const submitPaypal = (action$: ActionsObservable<Action>, state$: StateObservable<RootState>): Observable<Action> =>
    action$.ofType(SUBMIT_PAYPAL).pipe(
        mergeMap(action => {
            let request = (action as unknown as PaymentResult);

            return ajax.post("api/v1/webshop/paypal", (action as SubmitPayPal).request,  { "SBPPortal-Ticket": state$.value.login.ticket, "user": state$.value.login.username, "email": state$.value.login.email, 'Content-Type': 'application/json' })
                .pipe(map(response => {
                    return {
                        type: SUBMIT_PAYPAL_FULFILLED,
                        result: request,
                        vendor: "paypal"
                    }
                }),
                catchError(() => of({ type: SUBMIT_PAYMENT_FAILED })))

        }));

export const sendEmail = (action$: ActionsObservable<Action>, state$: StateObservable<RootState>): Observable<Action> =>
action$.ofType(SEND_EMAIL).pipe(
    mergeMap(action => {
        return ajax.post("api/v1/email", (action as SendEmail).request ,{ 'Content-Type': 'application/json' } )
            .pipe(map(() => {
                return {
                    type: SEND_EMAIL_FULFILLED
                }
            }),
            catchError((error) => of({ type: SEND_EMAIL_FAILED})))

    }));

export const webshopOnLogin = (action$: ActionsObservable<Action>, state$: StateObservable<RootState>): Observable<Action> =>
    action$.ofType(SUBMIT_LOGIN_FULFILLED).pipe(
        switchMap(action => of({
            type: LOAD_ORDERS,
        })));

export const loadOrders = (action$: ActionsObservable<Action>, state$: StateObservable<RootState>): Observable<Action> =>
    action$.ofType(LOAD_ORDERS).pipe(
        filter(action => {

            if (state$.value.login.payment_gateway == undefined) {
                return false;
            } else {
                return true;
            }


        }),
        switchMap(action => {

            return ajax.getJSON("api/v1/webshop/orders", { "SBPPortal-Ticket": state$.value.login.ticket, "user": state$.value.login.username, "email": state$.value.login.email }).pipe(
                map((orders) => {
                    return {
                        type: LOAD_ORDERS_FULFILLED,
                        orders
                    }

                }),
                catchError((error) => of({ type: LOAD_ORDERS_FAILED })))

        }))

export default function reducer(state = initialState, action: WebshopAction): WebshopState {
    switch (action.type) {
        case LOAD_ORDERS_FULFILLED: {
            return {
                ...state,
                orders: new Set(action.orders)
            }
        }

        case SUBMIT_PAYMENT: {
            return {
                ...state,
                failed: false,
                submitting: true,
                submitted: false
            };
        }

        case SUBMIT_PAYPAL: {
            return {
                ...state,
                failed: false,
                submitted: false,
                submitting: true
            }
        }

        case SUBMIT_PAYPAL_FULFILLED: {
            let result = action.result;


            return {
                ...state,
                submitting: false,
                submitted: true,
                result,
                vendor: "paypal"
            };
        }

        case SUBMIT_PAYMENT_FULFILLED: {

            let orders = state.orders;
            let result = action.result;

            result.items.forEach(item => orders.add(item.id));

            return {
                ...state,
                submitting: false,
                submitted: true,
                orders,
                result,
                vendor: "westpac"
            };
        }

        case TOGGLE_CHECKOUT: {
            return {
                ...state,
                submitted: false
            }

        }

        case SEND_EMAIL_FULFILLED: {
            return state;
        }
        case SEND_EMAIL_FAILED: {
            return state;
        }

        case SUBMIT_PAYMENT_FAILED:
            let result = action.result;

            return {
                ...state,
                failed: true,
                submitting: false,
                result
            };

        default:
            return state;
    }

}